import { useState } from 'react';

const faqItems = [
  {
    q: '蘑菇影院真的完全免费吗？需要注册吗？',
    a: '是的，蘑菇影院完全免费，无需注册、无需登录、无需付费即可在线观看所有影视内容。我们坚持免费电影在线和免费电视剧全集的承诺，让每一位用户都能无障碍享受观影乐趣。',
  },
  {
    q: '影片的画质如何？播放会缓冲吗？',
    a: '蘑菇影院全站提供1080P高清画质资源，采用多线路CDN加速技术确保流畅播放。正常情况下观看高清影片不会出现缓冲卡顿，如遇网络波动可尝试切换备用播放线路。',
  },
  {
    q: '影片更新频率是怎样的？',
    a: '我们每天更新50部以上的最新电影和电视剧集，包括院线新片、热门剧集同步更新。遇到大片上映或热门剧集更新时，通常能在24小时内上线高清资源，确保您第一时间看到想看的内容。',
  },
  {
    q: '手机和平板能看吗？需要下载APP吗？',
    a: '蘑菇影院完美适配手机和平板等移动设备，直接在浏览器中打开即可观看，无需下载任何APP。页面已针对触屏操作进行优化，支持手势控制播放进度和音量。',
  },
  {
    q: '想看的影片没有怎么办？',
    a: '您可以通过联系与投稿页面提交影片需求，我们的内容团队会尽快处理。同时您也可以浏览我们的专题合集和热门推荐，发现更多精彩内容。我们每日都在扩充资源库，覆盖越来越多的影视作品。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-foreground-500 text-sm">关于蘑菇影院的常见疑问，这里都有答案</p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, i) => (
              <div
                key={i}
                className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                >
                  <h3 className="font-semibold text-foreground-900 text-sm pr-4">{item.q}</h3>
                  <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 ${
                    openIndex === i ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-100 text-foreground-400'
                  }`}>
                    <i className="ri-add-line text-sm"></i>
                  </span>
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    openIndex === i ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                  }`}
                >
                  <p className="text-foreground-500 text-sm leading-relaxed">{item.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}